import { Link } from 'react-router-dom'
import { useMarkNotificationRead, useNotifications } from '../api/queries'
import { EmptyState, ErrorBox, Loading } from '../components/ui'
import { formatRelative } from '../lib/format'
import { PushCard } from '../components/PushCard'

/** Interne notifikationer (kravspec afsnit 29). Push tilføjes senere - se docs/TODO.md. */
export function NotificationsPage() {
  const { data, isLoading, error } = useNotifications()
  const markRead = useMarkNotificationRead()

  if (isLoading) return <Loading />
  if (error) return <ErrorBox error={error} />

  return (
    <div className="stack">
      <PushCard />

      {(!data || data.length === 0) && <EmptyState>Du har ingen notifikationer.</EmptyState>}

      {(data ?? []).map((notification) => {
        const content = (
          <>
            <div className="row row--between">
              <strong style={{ fontWeight: notification.isRead ? 500 : 700 }}>{notification.title}</strong>
              <span className="tiny muted">{formatRelative(notification.createdAt)}</span>
            </div>
            {notification.body && <div className="small muted">{notification.body}</div>}
          </>
        )

        return (
          <div
            key={notification.id}
            className="card card--flat"
            style={{ padding: 14, borderLeft: notification.isRead ? undefined : '3px solid var(--primary)' }}
            onClick={() => !notification.isRead && markRead.mutate(notification.id)}
          >
            {notification.link ? <Link to={notification.link}>{content}</Link> : content}
          </div>
        )
      })}
    </div>
  )
}
